import { render, staticRenderFns } from "./debito.vue?vue&type=template&id=81f5d720&"
import script from "./debito.vue?vue&type=script&lang=js&"
export * from "./debito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports